import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SearchIcon from "@material-ui/icons/Search";
import {
  TextField,
  Tooltip,
  IconButton,
  MenuItem,
  Button,
  Typography,
} from "@material-ui/core";
import FilterIcon from "mdi-material-ui/FilterOutline";

const F401InventoryItemViewFilter = (props) => {
  return (
    <Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center"
        }}
      >
        <div>
          <Typography variant="h5" color="primary" style={{ fontWeight: 700 }}>
           Items Stock Summary
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "70%",
            justifyContent: "flex-end",
          }}
        >
          <div>
            <Tooltip title="Table Filter">
              <IconButton
                style={{ marginLeft: "-10px" }}
                onClick={() => props.handleToggleTableFilter()}
              >
                <FilterIcon fontSize="default" color="primary" />
              </IconButton>
            </Tooltip>
          </div>
          <div
            style={{
              width: "30%",
              marginRight: 10
            }}
          >
            <TextField
              select
              id="categoryId"
              name="categoryId"
              fullWidth
              label="Category"
              size="small"
              variant="outlined"
              onChange={props.handleChange}
              value={props.state.categoryId}
              error={!!props.state.categoryIdError}
              helperText={props.state.categoryIdError}
              disabled={props.state.isLoading}
            >
              <MenuItem value={-1}>All</MenuItem>
              {props.state.categoriesData &&
                props.state.categoriesData.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.label || ""}
                    </MenuItem>
                  );
                })}
            </TextField>
          </div>
          {/* <div
            style={{
              width: "30%",
              marginRight: 10
            }}
          >
          </div>
          <div
            style={{
              width: "30%",
            }}
          >
            
          </div> */}
          <div>
            <Button
              style={{
                textTransform: "capitalize",
                marginLeft: 15,
                padding: 7.5,
                width: 110,
              }}
              onClick={() => props.onSearchButtonClick()}
              color="primary"
              variant="contained"
              disabled={props.state.isLoading}
            >
              <SearchIcon fontSize="small" style={{ marginRight: 5}}/> Search
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

F401InventoryItemViewFilter.propTypes = {
  state: PropTypes.object,
  handleChange: PropTypes.func,
  handleToggleTableFilter: PropTypes.func,
  onSearchButtonClick: PropTypes.func,
};

F401InventoryItemViewFilter.defaultProps = {
  state: {},
  handleChange: (fn) => fn,
  handleToggleTableFilter: (fn) => fn,
  onSearchButtonClick: (fn) => fn,
};

export default F401InventoryItemViewFilter;
